"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
//@ts-nocheck
const vue_property_decorator_1 = require("vue-property-decorator");
const bmk_ui_framework_1 = require("@biomemakers/bmk_ui_framework");
const floating_vue_1 = require("floating-vue");
const MapSideBarPanel_vue_1 = __importDefault(require("./MapSideBarPanel.vue"));
const ProjectsList_vue_1 = __importDefault(require("@becrop/components/Results/AreaProjectMap/Components/Projects/ProjectsList.vue"));
const ComparisonTeaser_vue_1 = __importDefault(require("./ComparisonTeaser.vue"));
const CustomerSwitcher_vue_1 = __importDefault(require("@becrop/components/Results/AreaProjectMap/Components/CustomerSwitcher.vue"));
const EventTracker_1 = __importDefault(require("@becrop/abstract/Utils/EventTracker"));
let MapSideBarPanelProjects = class MapSideBarPanelProjects extends vue_property_decorator_1.Vue {
    constructor() {
        super(...arguments);
        this.mainProjectToSearch = '';
        this.filteredMainProjects = this.mainProjectsList;
        this.enabledProjects = this.mainProjectsList;
        this.secondaryProjectToSearch = '';
        this.filteredSecondaryProjects = this.secondaryProjectsList;
        this.eventTracker = new EventTracker_1.default();
    }
    get internal_theme() {
        if (this.theme)
            return this.theme;
        return this.$theme.current.value;
    }
    eventTrackerListener(eventName, eventValues) {
        this.eventTracker.trackEvent(eventName, eventValues);
    }
    get isCurrentProjectComparable() {
        const notComparableProjects = ['farm', 'rate'];
        if (notComparableProjects.includes(this.mainProject.project_type))
            return false;
        return true;
    }
    filterMain(textSearch) {
        this.filteredMainProjects = this.enabledProjects.filter((fp) => fp.label.toLowerCase().includes(textSearch.toLowerCase()));
    }
    filterSecondary(textSearch) {
        this.filteredSecondaryProjects = this.secondaryProjectsList.filter((fp) => fp.label.toLowerCase().includes(textSearch.toLowerCase()));
    }
    updateMainProject(p) {
        this.$emit('updateMainProject', p);
        this.eventTrackerListener('updateFarm', { id: p.area_id, farm: p.area_name });
    }
    updateSecondaryProject(p) {
        this.$emit('updateSecondaryProject', p);
    }
    deployDoblePanel() {
        this.$emit('deployDoblePanel');
    }
    updated() {
        this.enabledProjects = this.mainProjectsList.filter((p) => (this.mode === 'single') ? p : p.project_type !== 'rate');
        this.filteredMainProjects = this.enabledProjects;
        this.filteredSecondaryProjects = this.secondaryProjectsList;
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: String, default: 'single' })
], MapSideBarPanelProjects.prototype, "mode", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: (Array), default: [] })
], MapSideBarPanelProjects.prototype, "mainProjectsList", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: (Array), default: [] })
], MapSideBarPanelProjects.prototype, "secondaryProjectsList", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Object, default: null })
], MapSideBarPanelProjects.prototype, "mainProject", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Object, default: null })
], MapSideBarPanelProjects.prototype, "secondaryProject", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Object, default: null })
], MapSideBarPanelProjects.prototype, "loadingDetailStatus", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Object, default: null })
], MapSideBarPanelProjects.prototype, "currentSubclient", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Boolean, default: false })
], MapSideBarPanelProjects.prototype, "isBiome", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: String, default: null })
], MapSideBarPanelProjects.prototype, "theme", void 0);
MapSideBarPanelProjects = __decorate([
    (0, vue_property_decorator_1.Options)({
        components: {
            Search: bmk_ui_framework_1.Search,
            Separator: bmk_ui_framework_1.Separator,
            MapSideBarPanel: MapSideBarPanel_vue_1.default,
            ProjectsList: ProjectsList_vue_1.default,
            ComparisonTeaser: ComparisonTeaser_vue_1.default,
            Loading: bmk_ui_framework_1.Loading,
            Dropdown: floating_vue_1.Dropdown,
            CustomerSwitcher: CustomerSwitcher_vue_1.default
        },
    })
], MapSideBarPanelProjects);
exports.default = MapSideBarPanelProjects;
